class CommunicationDirection {
    static Outbound() {
        return 1;
    }

    static Inbound() {
        return 2;
    }
}

export const getCommunicationDirectionTranslationKey = (direction) => {
    switch (direction) {
        case CommunicationDirection.Inbound():
            return 'customer.leadCommunicationDirectionInbound';
        case CommunicationDirection.Outbound():
            return 'customer.leadCommunicationDirectionOutbound';
        default:
            return null;
    }
};

export default CommunicationDirection;
